module.exports = __webpack_public_path__ + "assets/naixi.14858922.svg";